import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ef81a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modern-input-container" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["form", "required", "value", "type", "id", "min", "max", "maxLength", "pattern", "title", "disabled"]
const _hoisted_4 = ["value", "id", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (
        $props.type === 'select'
          ? $setup.toggleLabelClass($event.target.innerText, true)
          : undefined
      )),
      for: $props.id,
      class: _normalizeClass([
        'label',
        { focus: $setup.isInputFocused && !$props.disabled },
        { required: $props.required && !$props.disabled }
      ])
    }, _toDisplayString($props.label), 11, _hoisted_2),
    ($props.type !== 'select')
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          form: $props.form,
          required: $props.required,
          value: $props.hasMask ? $setup.mask($props.userData, $props.inputMask) : $props.userData,
          type: $props.type,
          id: $props.id,
          class: _normalizeClass(['input', { disabled: $props.disabled }]),
          min: $props.min,
          max: $props.max,
          maxLength: $props.maxLength,
          pattern: $props.pattern,
          title: $props.title,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:userData', $event.target.value))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleLabelClass($event.target.value, true))),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleLabelClass($event.target.value, false))),
          disabled: $props.disabled
        }, null, 42, _hoisted_3))
      : _createCommentVNode("", true),
    ($props.type === 'select')
      ? (_openBlock(), _createElementBlock("select", {
          key: 1,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:userData', $event.target.value))),
          onFocus: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleLabelClass($event.target.value, true))),
          onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleLabelClass($event.target.value, false))),
          class: "input input--select"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: option.id,
              id: option.id,
              key: index,
              class: "option",
              selected: option.id === $props.userData
            }, _toDisplayString(option.label), 9, _hoisted_4))
          }), 128))
        ], 32))
      : _createCommentVNode("", true)
  ]))
}